module.exports = __webpack_public_path__ + "static/media/agripreneurs_img1.e8d1987c.webp";